import { useEffect, useRef } from 'react';

import useInquiryForm from './useInquiryForm';
import useInquiryTypes from './useInquiryTypes';

interface Props {
    inquiryTypeId: string;
    setContent: ReturnType<typeof useInquiryForm>['setContent'];
    inquiryTypes: ReturnType<typeof useInquiryTypes>
}

/** 문의 유형이 바뀌면 내용을 유형별 기본 문구로 채운다 */
function useInquiryTypeContent({ inquiryTypeId, setContent, inquiryTypes }:Props) {
    const prevTypeIdRef = useRef<string>(inquiryTypeId);
    useEffect(() => {
        if (prevTypeIdRef.current === inquiryTypeId) {
            return;
        }
        prevTypeIdRef.current = inquiryTypeId;
        // 초기화 시에는 reset 이 내용을 비운다
        if (!inquiryTypeId) {
            return;
        }
        const inquiryType = inquiryTypes
            ?.find((type) => type.inquiryTypeId === inquiryTypeId);
        setContent(inquiryType?.content || '');
    }, [inquiryTypeId, inquiryTypes]);
}

export default useInquiryTypeContent;
